
import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { getLeaderBoardClear, getLeaderBoardReq } from "../../redux/user/actions";
import { SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import ShimmerNotification from "../Layouts/ShimmerNotification";
import "./LeaderboardHomeComp.scss";
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span className="shar-btn-home cursor-pointer" ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}>
    {children}
  </span>

));
const LeaderBoardHomeComp = ()=>{

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const leaderBoardDataTestRes = useSelector((state) => state.user.leaderBoard);
    
    const [leaderBoardData, setLeaderBoardData] = useState([]);
    const [lastUpdateTime, setLastUpdateTime] = useState("");

    const [isLoading, setIsLoading] = useState(false);
  
    const [selectedOfficeList, setSelectedOfficeList] = useState([]);
    const [tabKey,setTabKey] = useState("last_month");

    useEffect(() => {
        getLeaderBoardData();
      }, []);
      
    
      useEffect(() => {
        // console.log('leaderBoardDataTestRes: ',leaderBoardDataTestRes);
        if (!_.isEmpty(leaderBoardDataTestRes)) {
          setIsLoading(false)
          if (leaderBoardDataTestRes?.status === "success") {
            let tempArr = leaderBoardDataTestRes?.payload?.payload?.list;
            let finalArr = _.cloneDeep(tempArr)?.slice(0, 3);
            for (let i = 3; i < tempArr.length; i++) {
              if(tempArr[i].is_me){
                finalArr.push(tempArr[i])
                break;
              }
              
            }
            setLeaderBoardData(finalArr);
            setLastUpdateTime(
              moment
                .unix(leaderBoardDataTestRes?.payload?.payload?.last_updated)
                .format("Do MMMM YYYY, h:mm A")
            );
            dispatch(getLeaderBoardClear())
          }else {
            setLeaderBoardData([]);
          }
        }
      }, [leaderBoardDataTestRes]);
    
      let selectedOffice=[];
      selectedOfficeList.forEach(element => {
        selectedOffice.push(element.office_id)
      });
    
      //get leader board
      const getLeaderBoardData = () => {
        setIsLoading(true)
        dispatch(
          getLeaderBoardReq({
            module: "leaderBoard",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              user_id: localStorage.getItem(SessionKeys.USER_ID),
              office_id: selectedOffice,
              tab: tabKey
            },
          })
        );
      };


return(<>
    <div className="col-lg-6 col-md-6">
    <div className="leaderboard">
      <div className="header">
        <h1>Leaderboard</h1>
        <div className="icons">
        {false && <Dropdown className="social-share">
          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
          <svg
              width="48"
              height="48"
              viewBox="0 0 48 49"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="24"
                cy="24.5"
                r="23"
                stroke="#252526"
                strokeWidth="2"
              />
              <path
                d="M25.1202 29.0228L20.9213 26.7324C20.1914 27.5125 19.1526 28 18 28C15.7909 28 14 26.2091 14 24C14 21.7909 15.7909 20 18 20C19.1525 20 20.1912 20.4875 20.9212 21.2675L25.1202 18.9771C25.0417 18.6644 25 18.3371 25 18C25 15.7909 26.7909 14 29 14C31.2091 14 33 15.7909 33 18C33 20.2091 31.2091 22 29 22C27.8474 22 26.8087 21.5125 26.0787 20.7325L21.8798 23.0228C21.9583 23.3355 22 23.6629 22 24C22 24.3371 21.9583 24.6644 21.8798 24.9771L26.0788 27.2675C26.8087 26.4875 27.8474 26 29 26C31.2091 26 33 27.7909 33 30C33 32.2091 31.2091 34 29 34C26.7909 34 25 32.2091 25 30C25 29.6629 25.0417 29.3355 25.1202 29.0228ZM18 26C19.1046 26 20 25.1046 20 24C20 22.8954 19.1046 22 18 22C16.8954 22 16 22.8954 16 24C16 25.1046 16.8954 26 18 26ZM29 20C30.1046 20 31 19.1046 31 18C31 16.8954 30.1046 16 29 16C27.8954 16 27 16.8954 27 18C27 19.1046 27.8954 20 29 20ZM29 32C30.1046 32 31 31.1046 31 30C31 28.8954 30.1046 28 29 28C27.8954 28 27 28.8954 27 30C27 31.1046 27.8954 32 29 32Z"
                fill="#2D2D2D"
              />
            </svg>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <div className="sm_list">
              <div className="linkedin">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >

                  <circle
                    cx="15"
                    cy="15"
                    r="15"
                    fill="#000000"
                    data-name="Ellipse 180"
                  ></circle>
                  <circle
                    cx="13"
                    cy="13"
                    r="13"
                    fill="#fff"
                    data-name="Ellipse 181"
                    transform="translate(2 2)"
                  ></circle>
                  <path
                    fill="#000000"
                    d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                    data-name="Icon awesome-file-pdf"
                    transform="translate(9 7)"
                  ></path>
                </svg>
              </div>
              <div className="linkedin">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >

                  <circle
                    id="Ellipse_57"
                    data-name="Ellipse 57"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="#000000"
                  ></circle>
                  <circle
                    id="Ellipse_179"
                    data-name="Ellipse 179"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                  ></circle>
                  <g
                    id="surface1"
                    className="imageuploadsv"
                    transform="translate(5 4.586)"
                  >
                    <path
                      fill="#000000"
                      stroke="#000000"
                      d="M 3.332031 3.332031 C 2.421875 3.332031 1.667969 4.089844 1.667969 5 L 1.667969 15 C 1.667969 15.910156 2.421875 16.667969 3.332031 16.667969 L 16.667969 16.667969 C 17.578125 16.667969 18.332031 15.910156 18.332031 15 L 18.332031 5 C 18.332031 4.089844 17.578125 3.332031 16.667969 3.332031 Z M 3.332031 5 L 16.667969 5 L 16.667969 15 L 3.332031 15 Z M 12.082031 9.167969 L 9.167969 12.5 L 7.082031 10.417969 L 4.816406 13.332031 L 15.207031 13.332031 Z M 12.082031 9.167969 "
                    ></path>
                  </g>
                </svg>
              </div>
              <div className="facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"

                  id="facebook"
                  data-name="facebook"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >

                  <circle
                    id="Ellipse_198"
                    data-name="Ellipse 198"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="#000000"
                  ></circle>
                  <circle
                    id="Ellipse_199"
                    data-name="Ellipse 199"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                    className="fillwhite"
                  ></circle>
                  <path
                    id="Icon_awesome-facebook-f"
                    data-name="Icon awesome-facebook-f"
                    d="M8.9,8.2l.4-2.638H6.778V3.849A1.319,1.319,0,0,1,8.265,2.424H9.415V.178A14.031,14.031,0,0,0,7.373,0,3.22,3.22,0,0,0,3.926,3.55V5.56H1.609V8.2H3.926v6.376H6.778V8.2Z"
                    transform="translate(9.487 7.713)"
                    fill="#000000"
                  ></path>
                </svg>
              </div>
              <div className="linkedin">
                <svg
                  xmlns="http://www.w3.org/2000/svg"

                  id="linkedin"
                  data-name="linkedin"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >

                  <circle
                    id="Ellipse_57"
                    data-name="Ellipse 57"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="#000000"
                  ></circle>
                  <circle
                    id="Ellipse_179"
                    data-name="Ellipse 179"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                    className="fillwhite"
                  ></circle>
                  <path
                    id="Icon_awesome-linkedin-in"
                    data-name="Icon awesome-linkedin-in"
                    d="M2.781,12.424H.205V4.13H2.781ZM1.492,3A1.5,1.5,0,1,1,2.983,1.492,1.5,1.5,0,0,1,1.492,3Zm10.929,9.426H9.851V8.386c0-.962-.019-2.2-1.339-2.2-1.339,0-1.544,1.045-1.544,2.127v4.107H4.394V4.13h2.47V5.261H6.9A2.706,2.706,0,0,1,9.338,3.922c2.607,0,3.086,1.717,3.086,3.946v4.556Z"
                    transform="translate(8.788 8.789)"
                    fill="#000000"
                  ></path>
                </svg>
              </div>
            </div>
          </Dropdown.Menu>
        </Dropdown>}
        
          <button className="icon grid" onClick={()=>{navigate("/leaderboard")}}>
              <img src="/images/popt.svg" width={48} height={48} />
          </button>
        </div>
      </div>
      <div className="grid-container">
        <div className="grid-header rank">Rank</div>
        <div className="grid-header name">Name</div>
        <div className="grid-header score">Learning Points</div>
      </div>
      <div className="grid-body">
      {isLoading ? (
          <div className="lb-shimmer">
            {[1, 2, 3].map((m) => {
              return (
                <ShimmerNotification key={`notify-${m}-shimmer`} />
              );
            })}
          </div>
      ) :leaderBoardData.length>0?leaderBoardData.map((item,index)=>{
            return index < 3 && <div className="grid-container" key={index}>
                    <div className="grid-item rank highlight">{item?.rank}</div>
                      <div className="grid-item name highlight">
                           <img
                               src={_.isEmpty(item?.profile) ? "/images/avatar.png" : item?.profile}
                               alt={item?.name}
                               className="avatar"
                               width={24}
                               height={24}
                            />{" "}
                            {item?.name}
                        </div>
                    <div className="grid-item score highlight">{item?.score}</div>
                  </div>
       }):
       <div className="not-found cart-notfound">
                                    <div className="interboxes">
                                    <img src="/images/telescope.svg" alt="Not Found" />
                                    <p>No leaderboard yet.</p>
                                    </div>
                                </div>}
      
      
      {leaderBoardData.length>3 && <div className="grid-footer">
        <div className="grid-container myposition">
        <div className="grid-item rank">{leaderBoardData[3]?.rank}</div>
        <div className="grid-item name">
          <img
            src={_.isEmpty(leaderBoardData[3]?.profile) ? "/images/avatar.png" : leaderBoardData[3]?.profile}
            alt="Sarine Steward"
            className="avatar"
            width={24}
            height={24}
          />{" "}
          {leaderBoardData[3]?.name}
        </div>
        <div className="grid-item score">{leaderBoardData[3]?.score}</div>
      </div>
    </div>}
      </div>
    
    </div>
  </div>
</>)


}
export default LeaderBoardHomeComp;